"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var activeBreakpoint_enum_1 = require("../breakpoints/activeBreakpoint.enum");

function isLarge(activeBreakpoint) {
  return activeBreakpoint === activeBreakpoint_enum_1.ActiveBreakpointEnum.large;
}

exports.isLarge = isLarge;